import axios from "axios";

const getApiBaseUrl = () => {
  if (window.location.hostname === "localhost") {
    return "http://localhost:5000/api";
  }

  const configuredBaseUrl = process.env.REACT_APP_API_BASE_URL;

  if (!configuredBaseUrl) {
    return "/api";
  }

  if (configuredBaseUrl.startsWith("/")) {
    return configuredBaseUrl;
  }

  return configuredBaseUrl;
};

const apiClient = axios.create({
  baseURL: getApiBaseUrl(),
  withCredentials: true,
  // Gallery listings can involve Google Drive pagination and a cold Cloud Run
  // instance.  Fifteen seconds cancels valid requests before the API responds.
  timeout: 45000,
});

const getErrorMessage = (error) => {
  const message =
    error?.response?.data?.message ||
    error?.response?.data?.error ||
    error?.message ||
    "Something went wrong. Please try again.";

  if (Array.isArray(message)) {
    return message.join(", ");
  }

  return message;
};

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const normalizedError = new Error(getErrorMessage(error));
    normalizedError.status = error?.response?.status;
    normalizedError.code = error?.code;
    normalizedError.data = error?.response?.data;
    normalizedError.originalError = error;
    normalizedError.isNetworkError = !error?.response;
    throw normalizedError;
  }
);

export default apiClient;
